<script lang="ts">
	import type { Snippet } from "svelte";
	import type { HTMLAttributes } from "svelte/elements";
	import successCircle from "@core/assets/icons/success-circle.svg?raw";
	import warningCircle from "@core/assets/icons/warning-circle.svg?raw";
	import type { AlertType } from "./AlertType.js";
	import Icon from "./common/Icon.svelte";

	const {
		type,
		class: customClass,
		children,
		...props
	}: HTMLAttributes<HTMLDivElement> & { type: AlertType; children: Snippet } = $props();
</script>

<div
	{...props}
	class={[
		customClass,
		"flex p-4 gap-2",
		{ warning: "bg-cmcwarning-100 text-cmcwarning", success: "bg-cmcsuccess-100 text-cmcsuccess-200" }[type],
	]}
>
	<Icon icon={{ warning: warningCircle, success: successCircle }[type]} class="size-8" />
	<p class="mt-1 font-semibold text-base/tight tracking-[0.02em]">
		{@render children()}
	</p>
</div>
